import { parseInt } from "lodash";
import { API_END_POINTS } from "../../constant/config";
import Filter from "../../utils/Filter";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_CATEGORIES, GET_SINGLE_CATEGORY, UPDATE_CATEGORY } from "../type";

// Fetch Emails
export const fetchCategories = (query) => async (dispatch) => {
    try {
        const search = (query.search === undefined || query.search === "") ? "" : query.search;
        const apiEndpoint = API_END_POINTS.FETCH_CATEGORIES;
        const response = await JsonInterceptor.get(`${apiEndpoint}?page=${query.pageNumber}&limit=${query.pageSize}&search=${search}`)
        const filter = new Filter();
        const data = filter.baseFilter(response.data.data.docs, query);
        dispatch({
            type: GET_CATEGORIES,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Get Single Categories
export const fetchSingleCategory = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_CATEGORY;
        const response = await JsonInterceptor.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_CATEGORY,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// update Single Categories
export const updateCategory = (data) => async (dispatch) => {
    console.log("data")
    try {
        const body = {
            cart_category_id: parseInt(data.cart_category_id),
            category_order: data.cart_order
        }
        const apiEndpoint = API_END_POINTS.UPDATE_CATEGORIES;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, body)
        return dispatch({
            type: UPDATE_CATEGORY,
            payload: response.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};


